import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { EmptyAnnotationToolFilter, IAnnotationToolFilter } from '../../../imageFilters.model';
import { FilterContent } from '../FilterContent';
import { ImageFiltersFormProps } from '../ImageFiltersForm';
import { AnnotationToolRowForm } from './AnnotationToolRowForm';

export const AnnotationToolsBody = observer((props: ImageFiltersFormProps): ReactElement => {
  const { t } = useTranslator();

  const handleFilterToolChanged = (toolFilter: IAnnotationToolFilter): void => {
    const newArray = props.imageFilters.annotationTools.slice();
    const index = newArray.findIndex((x) => x.order === toolFilter.order);
    if (index > -1) {
      newArray.splice(index, 1, toolFilter);
      props.onSetAnnotationTools(newArray);
    }
  };

  const handleAddAnother = (): void => {
    const topOrder = props.imageFilters.annotationTools.map((x) => x.order).reduce((x, y) => (x > y ? x : y), 0);
    const newAnnotationTools = props.imageFilters.annotationTools.concat({
      ...EmptyAnnotationToolFilter,
      order: topOrder + 1,
    });
    props.onSetAnnotationTools(newAnnotationTools);
  };

  const handleDelete = (order: number): void => {
    const newSoring = props.imageFilters.annotationTools
      .filter((x) => x.order !== order)
      .sort((a, b) => a.order - b.order)
      .map((a, i) => ({ ...a, order: i }));

    props.onSetAnnotationTools(newSoring);
  };

  const tools = props.imageFilters.annotationTools;
  return (
    <FilterContent>
      {tools.map((x) => (
        <AnnotationToolRowForm
          key={x.order}
          availableImageFilters={props.availableFilters}
          toolFilter={x}
          showDelete={tools.length > 1}
          onToolFilterChanged={handleFilterToolChanged}
          onDelete={handleDelete}
        />
      ))}
      <div>
        <Button onClick={handleAddAnother}>+ {t('add_another')} </Button>
      </div>
    </FilterContent>
  );
});
